export default __webpack_public_path__ + "static/media/caution-diamond.a8e7d523.png";